module.exports = __webpack_public_path__ + "img/2.2fe11ade.jpg";